import React from "react";
import {SpinnerLoaderBox, SpinnerLoader} from "./style/SpinnerUI";

const Spinner = () => {
   return (
      <SpinnerLoaderBox>
         <SpinnerLoader />
      </SpinnerLoaderBox>
   );
};

export default Spinner;
